import logo from "./logo.svg";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import UserProfile from "./UserProfile";
import ProtectedRoute from "./ProtectedRoute";

function App() {
  // ✅ Get the user from localStorage
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Home />} />

          {/* ✅ Show Register only for admin */}
          <Route
            path="/register"
            element={
              user?.role === "admin" ? <Register /> : <Navigate to="/home" />
            }
          />

          {/* ✅ Protected route example */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
